<template>
  <section class="tool-page">
    <!-- Header (mock F4) -->
    <header class="tool-header">
      <div class="th-row">
        <h1>New paste</h1>
        <span class="th-chip mono">📋 Paste bin</span>
      </div>
      <p>Paste text or code, pick a syntax, and get a short link with a rendered snippet.</p>
    </header>
    <PasteTool />
  </section>
</template>

<script>
import PasteTool from '@/components/tools/PasteTool.vue';

export default {
  name: 'PasteView',
  components: { PasteTool },
};
</script>

<style scoped>
.tool-page {
  max-width: 980px;
  margin: 0 auto;
  padding: clamp(24px, 4vw, 40px) clamp(16px, 4vw, 40px) 80px;
}
.tool-header { margin-bottom: 22px; }
.th-row { display: flex; align-items: center; gap: 11px; margin-bottom: 6px; flex-wrap: wrap; }
.tool-header h1 {
  font-size: 36px;
  line-height: 1;
  margin: 0;
  color: var(--text);
}
.th-chip {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--accent-h);
  background: var(--accent-soft);
  border: 1px solid var(--border-strong);
  border-radius: 4px;
  padding: 3px 8px;
  white-space: nowrap;
}
.tool-header p { color: var(--faint); font-size: 14px; margin: 0; }
.mono { font-family: var(--font-mono); }
</style>
